module.exports = __webpack_public_path__ + "static/fonts/BMDOHYEON_otf.otf?36832d8a";